import React, {Component} from 'react'
import InputBarcode from "./InputBarcode"
import BasketDetail from "./BasketDetail"
import addItemToBasket from "../actions/addItemToBasket"
import classNames from 'classnames'
import * as applyBrandingForAllItems from "../../../configs/applyBrandingForAllItems"
import { notification } from 'antd'


class MergerPage extends Component {
    constructor(props) {
        super(props);
        this.notifRootRef = React.createRef();
    }
    state = {
        barcode: '',
        loading: false,
        result: null,
        error: ''
    }

    _handleSubmit = (barcode, fac) => {
        this.setState({
            barcode,
        }, () => this._submitBarcode(fac))
    }

    _submitBarcode = async (fac = '1C') => {
        const {barcode, loading} = this.state
        const vBarcode = barcode.replace(/#/gi, '')

        if (loading) return false

        this.setState({
            loading: true,
        })

        try {
            const data = await addItemToBasket(vBarcode, fac, this.notifRootRef)

            const {errors = []} = {...data}
            // Đơn huỷ: API trả kèm cả lỗi "Không tìm thấy mã đơn" — ưu tiên báo lý do huỷ
            const cancelledError = errors.find(item => `${item.key || ''}`.startsWith('ORDER_CANCELLED_'))
            const uniqueErrors = cancelledError
                ? [{error: `Item ${vBarcode} đã bị ${/ship/i.test(cancelledError.error) ? 'hủy ship' : 'hủy'}.`}]
                : Array.from(new Map(errors.map(item => [item.barcodeNumber, item])).values()) || []

            if(!!uniqueErrors.length) {
                return this.setState({
                    error: uniqueErrors.map(i => i.error).join(', '),
                    loading: false,
                    barcode: '',
                    result: null,
                })
            }

            this.setState({
                loading: false,
                result: data,
                error: '',
                barcode: ''
            })
        } catch (e) {
            this.setState({
                error: e.message || e,
                loading: false,
                barcode: '',
                result: null,
            })
        }
    }

    _handleSetData = (data) => {
        this.setState({
            loading: false,
            result: data,
            error: '',
            barcode: ''
        })
    }

    _handleOnChange = value => {
        this.setState({
            barcode: value,
        })
    }

    _handleClose = (afterClose = null) => {
        notification.destroy()
        this.setState({
            barcode: '',
            result: null,
            error: '',
        }, () => {
            typeof afterClose === 'function' && afterClose()
        })
    }

    render() {
        const {loading, barcode, result, error} = this.state
        const isAppliedBrandingForAllItems = applyBrandingForAllItems.isSupport(result && result.barcode)

        return (
            <div className={classNames("MergerPage", {loading})}>
                <div id="notif-top-center-root" ref={this.notifRootRef} />
                <InputBarcode
                    onClose={this._handleClose}
                    loading={loading}
                    value={barcode}
                    onChange={this._handleOnChange}
                    onSubmit={this._handleSubmit}
                    data={result}
                />
                {
                    !!error &&
                    <div className="alert alert-danger">
                        <div className="Huge">
                            {/* <strong>Lỗi: </strong> */}
                            <span>{error}</span>
                        </div>
                    </div>
                }

                {
                    !!result &&
                    <BasketDetail 
                        onClose={this._handleClose} 
                        result={result}
                        isAppliedBrandingForAllItems={isAppliedBrandingForAllItems} 
                        showImage
                        onSetData={this._handleSetData}
                        containerRef={this.notifRootRef}
                    />
                }
            </div>
        )
    }
}

export default MergerPage
